var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecisionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1316_4214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72354 3.77583C9.91394 3.5854 9.91394 3.27668 9.72354 3.08628L9.43706 2.7998H12.7997C13.1679 2.7998 13.4663 3.09828 13.4663 3.46647C13.4663 3.83466 13.1679 4.13314 12.7997 4.13314H9.36621L9.72354 3.77583Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63285 4.13314H3.19938C2.83119 4.13314 2.53271 3.83466 2.53271 3.46647C2.53271 3.09828 2.83119 2.7998 3.19938 2.7998H6.562L6.27551 3.08628C6.08511 3.27668 6.08511 3.5854 6.27551 3.77583L6.63285 4.13314Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6665 2.14386C11.3776 2.85497 11.3776 4.0079 10.6665 4.71902L9.28739 6.09811C8.57629 6.80924 7.42333 6.80924 6.71224 6.09811L5.33314 4.71902C4.62202 4.0079 4.62202 2.85497 5.33314 2.14386L6.71224 0.764779C7.42333 0.0536675 8.57629 0.0536672 9.28739 0.764779L10.6665 2.14386ZM9.72368 3.77622C9.91408 3.5858 9.91408 3.27708 9.72368 3.08668L8.34459 1.70759C8.15416 1.51718 7.84547 1.51718 7.65504 1.70759L6.27594 3.08668C6.08554 3.27708 6.08554 3.5858 6.27594 3.77622L7.65504 5.15531C7.84547 5.34572 8.15416 5.34572 8.34459 5.15531L9.72368 3.77622Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86605 3.69792C3.86605 3.32973 3.56757 3.03125 3.19938 3.03125C2.83119 3.03125 2.53271 3.32973 2.53271 3.69792V7.2H3.86605V3.69792Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86605 10.4004H2.53271V13.2983C2.53271 13.6665 2.83119 13.965 3.19938 13.965C3.56757 13.965 3.86605 13.6665 3.86605 13.2983V10.4004Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.13327 5.86719H4.2666C5.29753 5.86719 6.13327 6.70292 6.13327 7.73385V9.86719C6.13327 10.8981 5.29753 11.7339 4.2666 11.7339H2.13327C1.10234 11.7339 0.266602 10.8981 0.266602 9.86719V7.73385C0.266602 6.70292 1.10234 5.86719 2.13327 5.86719ZM2.13327 7.20052C1.83872 7.20052 1.59993 7.43929 1.59993 7.73385V9.86719C1.59993 10.1617 1.83872 10.4005 2.13327 10.4005H4.2666C4.56116 10.4005 4.79994 10.1617 4.79994 9.86719V7.73385C4.79994 7.43929 4.56116 7.20052 4.2666 7.20052H2.13327Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4661 3.69792C13.4661 3.32973 13.1677 3.03125 12.7995 3.03125C12.4313 3.03125 12.1328 3.32973 12.1328 3.69792V7.34506C12.3358 7.25192 12.5616 7.2 12.7995 7.2C13.0374 7.2 13.2632 7.25192 13.4661 7.34506V3.69792Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4661 10.2549C13.2632 10.348 13.0374 10.3999 12.7995 10.3999C12.5616 10.3999 12.3358 10.348 12.1328 10.2549V13.2979C12.1328 13.6661 12.4313 13.9645 12.7995 13.9645C13.1677 13.9645 13.4661 13.6661 13.4661 13.2979V10.2549Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8005 11.7339C11.1805 11.7339 9.86719 10.4205 9.86719 8.80052C9.86719 7.18049 11.1805 5.86719 12.8005 5.86719C14.4205 5.86719 15.7339 7.18049 15.7339 8.80052C15.7339 10.4205 14.4205 11.7339 12.8005 11.7339ZM12.8005 7.20052C11.9169 7.20052 11.2005 7.91687 11.2005 8.80052C11.2005 9.68417 11.9169 10.4005 12.8005 10.4005C13.6842 10.4005 14.4005 9.68417 14.4005 8.80052C14.4005 7.91687 13.6842 7.20052 12.8005 7.20052Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60484 15.4439C3.39132 15.7108 2.98543 15.7108 2.77191 15.4439L1.74824 14.1644C1.46888 13.8152 1.7175 13.2979 2.16471 13.2979H4.21204C4.65924 13.2979 4.90786 13.8152 4.6285 14.1644L3.60484 15.4439Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2059 15.4439C12.9924 15.7108 12.5865 15.7108 12.373 15.4439L11.3493 14.1644C11.0699 13.8152 11.3186 13.2979 11.7658 13.2979H13.8131C14.2603 13.2979 14.5089 13.8152 14.2296 14.1644L13.2059 15.4439Z",
    fill: "#383838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1316_4214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecisionIcon);
export default __webpack_public_path__ + "static/media/decision_icon.82161fa737823156b8ec12f19fb43177.svg";
export { ForwardRef as ReactComponent };